import React, { Component } from "react";
import { Badge } from "reactstrap";
import { Link } from "react-router-dom";
import { getTicketConnector } from "../../dataconnector/ticketDatabaseConnector";

class TicketNotificationBadge extends Component {
  state = {
    openCount: 0,
  };

  componentDidMount() {
    const connector = getTicketConnector();
    this.unsubscribe = connector.subscribeToOpenTicketsCount((count) => {
      this.setState({ openCount: count });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    const { openCount } = this.state;
    const { destination = "/AdminTicketsView" } = this.props;

    return (
      <Link
        to={destination}
        className="nav-link position-relative"
        style={{ padding: "0.5rem 1rem" }}
      >
        <em
          className="fas fa-headset"
          style={{ fontSize: "1.3rem", color: "white" }}
        ></em>
        {openCount > 0 && (
          <Badge
            color={openCount > 5 ? "danger" : "warning"}
            pill
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              fontSize: "0.7rem",
              minWidth: "20px",
              height: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #fff",
            }}
          >
            {openCount > 99 ? "99+" : openCount}
          </Badge>
        )}
      </Link>
    );
  }
}

export default TicketNotificationBadge;
